import Component from '../abstracts/Component';

export default class SizeRowComponent extends Component {

  get SELECTORS() {
    return {
      main: '.c-sizes-row:not([data-into-sticky="true"]',
      sizeContainer: '.c-s-r__wrapper',
      sizeBtn: '.c-s-r__size',
    };
  }

  constructor() {
    super();
  }
  initCarousel(){
    let sizesContainer = document.querySelectorAll(this.SELECTORS.main);
    let mq = window.matchMedia('(max-width: 767px)');
    
    let options = {
      dots: false,
      arrows: false,
      infinite: false,
      centerMode: false,
      draggable: true,
      slidesToShow: 4.5,
      slidesToScroll: 1,
    };
    
    // for( let container of sizesContainer){
    //   let sizeRow = container.querySelector(this.SELECTORS.sizeContainer);
    //   if(mq.matches){
    //     $(sizeRow).slick(options);
    //   }

    //   mq.addListener((e)=>{
    //     if(e.matches){
    //       $(sizeRow).slick(options);
    //     }else{
    //       $(sizeRow).slick('unslick');
    //     }
    //   })
    // }
    
  }
  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
        module => {
          this.initCarousel();
        },
        error => {
          console.error("failed to load slick ", error.stack);
        }
    );
  }
  
  render() {
    super.render();
    if(document.querySelector(this.SELECTORS.main)){
      this.importSlick();
    }
  }
}
